import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router";

import { PERSONAL_API_KEY_DETAILS_URL_PARAM } from "components/ApiKeys/PersonalApiKeys/constants";

import { showPersonalSettingsApiKeysDetailsDrawer } from "./DetailsDrawer";
import { PersonalApiKey } from "./gql";

const usePersonalSettingsApiKeysDetailsFromUrl = (apiKeys: PersonalApiKey[], loading: boolean) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const handledRef = useRef(false);

  const apiKeyId = searchParams.get(PERSONAL_API_KEY_DETAILS_URL_PARAM);

  useEffect(() => {
    if (handledRef.current || !apiKeyId || loading) {
      return;
    }
    handledRef.current = true;

    const apiKey = apiKeys.find(({ id }) => id === apiKeyId);

    if (apiKey) {
      showPersonalSettingsApiKeysDetailsDrawer({ id: apiKey.id, apiKey });
    }

    const nextParams = new URLSearchParams(searchParams);
    nextParams.delete(PERSONAL_API_KEY_DETAILS_URL_PARAM);
    setSearchParams(nextParams, { replace: true });
  }, [apiKeyId, apiKeys, loading, searchParams, setSearchParams]);
};

export default usePersonalSettingsApiKeysDetailsFromUrl;
